module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vrassets/_next/static/images/gold_foil_tag@2x-0d3f0932274d811665be31bf61a403fc.png";